// extracted by mini-css-extract-plugin
export var autoExpand = "_1s-b";
export var container = "_1s-a";
export var containerWidth = "_1s-8";
export var disabled = "_1s-2";
export var error = "_1s-3";
export var fullWidth = "_1s-9";
export var highlightContainer = "_1s-5";
export var inputWrapper = "_1s-0";
export var small = "_1s-1";
export var textarea = "_1s-4";
export var validatedTextarea = "_1s-6";
export var visuallyHidden = "_1s-7";